import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Col, Card, Row } from 'react-bootstrap';
import classNames from 'classnames';

const Title = ({ titleTag: TitleTag, className, breakPoint, children }) => (
  <TitleTag className={classNames('text-800', className)}>{children}</TitleTag>
);

const CustomTooltip = ({ content }) =>
  content ? (
    <div
      style={{
        position: 'absolute',
        // top: position.top,
        // left: position.left,
        background: 'white',
        color: 'black',
        padding: '8px',
        borderRadius: '4px',
        zIndex: 1000, // Adjust the z-index as needed
        fontSize: '14px',
        maxWidth: '93%',
        borderColor: '#d3d3d3',
        border: '1px solid #d3d3d3',
        boxShadow: '1px 1px 5px rgba(0, 0, 0, 0.1)',
        lineHeight: '1.2'
      }}
      className="custom-tooltip"
    >
      <span style={{ fontSize: '12px' }}>{content}</span>
    </div>
  ) : (
    <></>
  );

const FalconCardHeader = ({
  title,
  light,
  titleTag,
  titleClass,
  className,
  breakPoint,
  endEl,
  children,
  desc,
  infoBtn,
  radioFilter
}) => {
  const domain = window.location.hostname;
  const clientName = domain?.split('.')[0].toUpperCase();

  const [isTooltipVisible, setTooltipVisible] = useState(false);

  const handleTitleHover = () => {
    setTooltipVisible(true);
  };

  const handleTitleLeave = () => {
    setTooltipVisible(false);
  };

  return (
    <Card.Header className={classNames(className, { 'bg-light': light })}>
      {endEl ? (
        <Row className="d-flex justify-content-center align-items-center">
          <Col style={{ width: 'fit-content' }}>
            <span
              onMouseEnter={handleTitleHover}
              onMouseLeave={handleTitleLeave}
              style={{ cursor: 'pointer' }}
            >
              <Title
                breakPoint={breakPoint}
                titleTag={titleTag}
                className={titleClass}
              >
                {title}
                <span style={{ marginLeft: 5, cursor: 'pointer' }}>
                  {infoBtn}
                </span>
              </Title>
            </span>
            {isTooltipVisible && <CustomTooltip content={desc} />}
            {radioFilter && (
              <div className="d-flex flex-column gap-2">{radioFilter}</div>
            )}
          </Col>
          <Col
            {...{ [breakPoint ? breakPoint : 'xs']: 'auto' }}
            className={`text${breakPoint ? `-${breakPoint}` : ''}-right ps-0`}
          >
            {endEl}
          </Col>
        </Row>
      ) : (
        <span onMouseEnter={handleTitleHover} onMouseLeave={handleTitleLeave}>
          <Title
            breakPoint={breakPoint}
            titleTag={titleTag}
            className={titleClass}
          >
            {title}
          </Title>
          {/* {isTooltipVisible && <CustomTooltip content={title} />} */}
        </span>
      )}
    </Card.Header>
  );
};

Title.propTypes = {
  breakPoint: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl', 'xxl']),
  titleTag: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  className: PropTypes.string,
  children: PropTypes.node
};

Title.defaultProps = { titleTag: 'h5' };

CustomTooltip.propTypes = {
  content: PropTypes.node
};

FalconCardHeader.propTypes = {
  title: PropTypes.node,
  light: PropTypes.bool,
  breakPoint: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl', 'xxl']),
  endEl: PropTypes.node,
  radioFilter: PropTypes.node,
  infoBtn: PropTypes.node,
  titleTag: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  titleClass: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  desc: PropTypes.node // Add prop type for data
};

export default FalconCardHeader;
